import React from "react";
import Images from "../assets/Image";
import { Link, useNavigate } from "react-router-dom";
import { SOCIAL_LINKS } from "../utils/constants";

export default function Footer() {
  const navigate = useNavigate();
  const goToSection = (id) => {
    sessionStorage.setItem("scrollTarget", id);
    navigate("/"); // Navigates to home, Home.jsx will handle the scroll
  };

  return (
    <div className="FooterMainContainer">
      <div className="imageContainer">
        <div className="leftImgContainer ">
          <div className="leftTxtContainer">
            <div>
              <img className="leftIcon" src={Images?.locationIcon} alt="" />
            </div>
            <p className="leftTxt">Come visit and explore our location </p>
            <div
              className="leftBtn"
              onClick={() => {
                window.open(
                  "https://www.google.com/maps/place/USP+Packaging+Solutions+Pvt+Ltdhttps://www.google.com/maps/place/USP+Packaging+Solutions+Pvt+Ltd/@13.0050458,80.2550207,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5267ec8a16ae31:0x36d6645adf4b55d0!8m2!3d13.0050458!4d80.2575956!16s%2Fg%2F11gdkph19r?entry=ttu&g_ep=EgoyMDI1MDQwMi4xIKXMDSoASAFQAw%3D%3D",
                  "_blank",
                );
              }}
            >
              Get Direction
            </div>
          </div>
        </div>
        <div className="RightImgContainer">
          <div className="leftTxtContainer">
            <div>
              <img className="leftIcon" src={Images?.profileIcon} alt="" />
            </div>
            <p className="leftTxt">Get help from USP packaging Team</p>
            <div
              className="leftBtn"
              onClick={() => {
                navigate("/services/contactus");
              }}
            >
              Contact Us
            </div>
          </div>
        </div>
      </div>
      <div className="footerContentContainer">
        <div className="footerContent">
          <div className="logoContainer">
            <img className="logoImg" src={Images?.uspLogo} alt="logo" />
            <p className="logoTxt">
              Old No. 15/1, New No. 37,
              <br />
              Dr.Muthulakshmi Salai,
              <br />
              Lattice Bridge Road, Adyar,
              <br />
              Chennai 600 020, INDIA.
            </p>
            <div className="socialMediaContainer">
              {/* <img src={Images?.instagram} alt="instagramLogo" /> */}
              <a
                href={SOCIAL_LINKS.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                <img src={Images?.linkedin} alt="linkedinLogo" />
              </a>
              {/* <img src={Images?.facebook} alt="facebookLogo" /> */}
              <a
                href={SOCIAL_LINKS.youtube}
                target="_blank"
                rel="noreferrer"
              >
                <img src={Images?.youtube} alt="youtubeLogo" />
              </a>
              {/* <img src={Images?.whatapp} alt="whatappLogo" /> */}
            </div>
          </div>
          <div className="txtContainer">
            <div className="txtContent">
              <ul className="txtUnList">
                <li>
                  <strong>Our Product</strong>
                </li>
                <li>
                  <Link to="/#consumables">Consumables</Link>
                </li>
                <li>
                  <Link to="/#cij_printer">CIJ Printers</Link>
                </li>
                <li>
                  <Link to="/#tto_printer">TTO Printers</Link>
                </li>
                <li>
                  <Link to="/#resolution_printer">Hi-Resolution Printers</Link>
                </li>
                <li>
                  <Link to="/#laser_coding_system">Laser Coding Systems</Link>
                </li>
              </ul>
              <ul className="txtUnList">
                <li>
                  <strong>Quick Links</strong>
                </li>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/services/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/services/support">Services & Support</Link>
                </li>
                {/* <li>SWM</li> */}
                <li>
                  <Link to="/services/event">Event</Link>
                </li>
              </ul>
              <ul className="txtUnList">
                <li>
                  <strong>Solution By</strong>
                </li>
                <li>
                  <Link to="/solutions/byIndustry">Solution By Industry</Link>
                </li>
                <li>
                  <Link to="/solutions/byApplication">
                    Solution By Application
                  </Link>
                </li>
                <li>
                  <Link to="/knowUs">
                    <strong>Know Us</strong>
                  </Link>
                </li>
                <li>
                  <Link to="/services/contactus">
                    <strong>Contact Us</strong>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p className="copyRightTxt">
        Developed by 2K VIRTUAL WORLD | ©USP 2005. All Rights Reserved.
      </p>
    </div>
  );
}
